var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticClass:"align-middle",attrs:{"src":_vm.logo,"width":_vm.size,"transition":"scale-transition"}})}
var staticRenderFns = []

export { render, staticRenderFns }